import React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from '@/components/Typography/Text';
import { useTheme } from '@/context/ThemeContext';
import { getModelPricing } from '@/utils/model_pricing';

export default function ModelPriceTier({ model, variant = 'default' }) {
  const { colors } = useTheme();
  const price = getModelPricing(model);
  if (!price) return null;

  return (
    <View
      accessible
      accessibilityLabel={model.videoPromotion?.enabled ? `10% off video credits. Relative price: ${price.tier} of 4` : `Relative price: ${price.tier} of 4`}
      accessibilityHint="More dollar signs mean a higher starting credit cost."
      style={[styles.badge, { backgroundColor: variant === 'plain' ? 'transparent' : colors.solid_color_tertiary }, variant === 'plain' && styles.plain]}
    >
      <Text
        size={variant === 'plain' ? 'm' : 'xxs'}
        weight={variant === 'plain' ? 'bold' : 'semibold'}
        color={variant === 'plain' ? 'primary' : 'secondary'}
        style={styles.symbols}
      >
        {price.symbols}
      </Text>
      {model.videoPromotion?.enabled && <Text size="xxs" weight="semibold" color="secondary">10% off video</Text>}
    </View>
  );
}

const styles = StyleSheet.create({
  badge: { flexShrink: 0, paddingHorizontal: 7, paddingVertical: 3, borderRadius: 5 },
  plain: { paddingHorizontal: 0 },
  symbols: { letterSpacing: 1 },
});
